import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { PenLine, BookOpen, Brain, Trophy, User, BarChart3 } from "lucide-react";
import { PlanBanner } from "@/components/PlanBanner";
import { NotifPrompt } from "@/components/NotifPrompt";
import { InstallPrompt } from "@/components/InstallPrompt";
import { useAuth } from "@/context/AuthContext";
import { useClaimTrial } from "@/lib/trial";
import { syncPush } from "@/lib/push";
import { OfflineBanner, SyncManager } from "@/components/Offline";

const TABS = [
  { to: "/", label: "Log", icon: PenLine, id: "log" },
  { to: "/journal", label: "Journal", icon: BookOpen, id: "journal" },
  { to: "/quizzes", label: "Quiz", icon: Brain, id: "quiz" },
  { to: "/analytics", label: "Stats", icon: BarChart3, id: "analytics" },
  { to: "/ranks", label: "Ranks", icon: Trophy, id: "ranks" },
  { to: "/profile", label: "Profile", icon: User, id: "profile" },
];

export default function AppShell() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  useClaimTrial(user);
  const remindersOn = !!user?.reminders_enabled;
  useEffect(() => {
    if (remindersOn) syncPush().catch(() => {});
  }, [remindersOn]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#050505]">
      <div className="relative z-10 max-w-md mx-auto min-h-screen bg-[#0A0A0A] md:border-x md:border-[#18181B] pb-28">
        <OfflineBanner />
        <PlanBanner />
        <Outlet />
        <NotifPrompt />
        <InstallPrompt />
        <SyncManager />
      </div>
      <nav
        data-testid="bottom-nav"
        className="fixed bottom-0 inset-x-0 z-50 max-w-md mx-auto bg-[#0A0A0A]/90 backdrop-blur-md border-t border-[#1F1F23] safe-bottom"
      >
        <div className="flex px-1.5 pt-2">
          {TABS.map(({ to, label, icon: Icon, id }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={`nav-${id}`}
              className={({ isActive }) =>
                `flex-1 min-w-0 flex flex-col items-center gap-1 py-1.5 rounded-xl transition-colors duration-200 ${
                  isActive ? "text-white" : "text-[#71717A] hover:text-[#A1A1AA]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={21} strokeWidth={isActive ? 2.4 : 1.8} className={isActive ? "text-[#E50914]" : ""} />
                  <span className="text-[9.5px] font-semibold uppercase tracking-wider">{label}</span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
